import React from 'react';
import SpinnerLoader from '../../SpinnerLoader/SpinnerLoader';
import CycleSettingsMode from '../../CycleSettingsMode/CycleSettingsMode';
import Delimiter from '../../Delimiter/Delimiter';
import CycleSettingsEnum from '../../../enums/cycle-setting.enum';
import PreHeatSettings from '../../PreHeatSettings/PreHeatSettings';
import PercentageTimerSettings from '../../PercentageTimerSettings/PercentageTimerSettings';
import RecorderSettings from '../../RecorderSettings/RecorderSettings';
import { PostWeldSettings } from '../../PostWeldSettings/PostWeldSettings';

interface Props {
  isLoading: boolean;
  isShowContent: boolean;
  localMode: CycleSettingsEnum | null;
  cycleId: string;
  cycleDbSettings: { mode: CycleSettingsEnum; updated_at: string } | null;
  setLocalMode: (mode: CycleSettingsEnum) => void;
}

const ModeSettingsPanel: React.FC<Props> = ({
  isLoading,
  isShowContent,
  localMode,
  cycleId,
  cycleDbSettings,
  setLocalMode,
}) => {
  const MODE_COMPONENTS: Record<CycleSettingsEnum, JSX.Element> = {
    [CycleSettingsEnum.PostWeld]: <PostWeldSettings cycleId={cycleId} />,
    [CycleSettingsEnum.PreHeat]: <PreHeatSettings cycleId={cycleId} />,
    [CycleSettingsEnum.PercentageTimer]: <PercentageTimerSettings cycleId={cycleId} />,
    [CycleSettingsEnum.Recorder]: <RecorderSettings />,
  };

  return (
    <div className="flex h-full w-full flex-col items-center sm:p-10">
      {isLoading && (
        <div className="flex h-full w-full items-center justify-center">
          <SpinnerLoader />
        </div>
      )}
      {isShowContent && cycleDbSettings && localMode && (
        <>
          <div className="w-full max-w-screen-lg pb-4">
            <CycleSettingsMode
              mode={{ value: cycleDbSettings.mode, timestamp: new Date(cycleDbSettings.updated_at).getTime() }}
              cycleId={cycleId}
              onSubmit={setLocalMode}
            />
          </div>
          <Delimiter />
          <div className="w-full max-w-screen-lg">{MODE_COMPONENTS[localMode]}</div>
        </>
      )}
    </div>
  );
};

export default ModeSettingsPanel;
